import projectsApi from '@/api/v1/projects';
import router from '@/router/index';
import utils from '@/helpers/utils';

export default {
  namespaced: true,

  state: {
    project: {
      name: '',
      projectType: '',
      media: [],
      deadline: '',
      description: '',
      discLocation: '',
      copy: '',
      adminReview: null,
    },
    isProcessing: false,
  },

  mutations: {
    CHANGE_PROCESSING_STATUS(state, status) {
      state.isProcessing = status;
    },
  },

  actions: {
    createProject({ commit, dispatch }, project) {
      commit('CHANGE_PROCESSING_STATUS', true);

      const projectFormData = new FormData();
      utils.buildFormData(projectFormData, project);

      projectsApi.projects.create(projectFormData)
        .then((resp) => {
          const projectId = resp.data.id;

          dispatch('snackbar/showSnackbar', {
            message: ['Utworzono projekt'],
            type: 'success',
          }, { root: true });
          commit('CHANGE_PROCESSING_STATUS', false);
          dispatch('chat/fetchChannels', undefined, { root: true });
          router.push({ name: 'project-single', params: { id: projectId } });
        })
        .catch(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    changeProcessingStatus({ commit }, status) {
      commit('CHANGE_PROCESSING_STATUS', status);
    },
  },
};
